import { React, useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";

import { Button } from "../../../commonComponents/Buttons";

import { UploadFileError, UploadFileImg } from "../../../../assets";

function VideoUpload({ file, setFile, fileAccept, fileMaxSize }) {
  const { t } = useTranslation();
  const [formatError, setFormatError] = useState(false);
  const [sizeError, setSizeError] = useState(false);

  const onDrop = useCallback(
    (acceptedFiles) => {
      setFile(acceptedFiles[0]);
    },
    [setFile]
  );

  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: fileMaxSize,
    accept: fileAccept,
  });

  useEffect(() => {
    if (fileRejections[0]?.errors[0]?.code === "file-invalid-type") {
      setFormatError(true);
    } else {
      setFormatError(false);
    }

    if (fileRejections[0]?.errors[0]?.code === "file-too-large") {
      setSizeError(true);
    } else {
      setSizeError(false);
    }
  }, [formatError, sizeError, fileRejections]);

  function removeVideo() {
    setFile(null);
  }

  function renderInfo() {
    if (formatError) {
      return (
        <>
          <p>
            {t("unsupportedVideoFormat")}
            <span className="linkColor">{t("tryAgain")}</span>
          </p>
          <p className="reqTxt">
            <span>{t("videoFormat")}: mp4, mov, qt, avi, webm.</span>
          </p>
        </>
      );
    } else if (sizeError) {
      return (
        <>
          <p>
            {t("bigVideoSize")}{" "}
            <span className="linkColor">{t("tryAgain")}</span>
          </p>
          <p className="reqTxt">
            <span>{t("videoSizeLimit")}</span>
          </p>
        </>
      );
    } else if (!formatError && !sizeError) {
      return (
        <>
          <p>{t("dragDrop")}</p>
          <p>
            {t("dragDropExplain")}{" "}
            <span className="linkColor">{t("browseManually")}</span>.
          </p>
          <p className="reqTxt">
            <span>{t("videoFormat")}: mp4, mov, qt, avi, webm.</span>{" "}
            <span>{t("videoSizeLimit")}</span>
          </p>
        </>
      );
    }
  }

  return (
    <>
      {file ? (
        <div className="challengePreviewBlock withBorder">
          <Button
            iconClassName="hasIcon--close"
            viewType="transparentIcon"
            customClassName="removeVideo"
            onClick={() => removeVideo()}
          />
          <video
            preload="metadata"
            className="challengePreview"
            src={URL.createObjectURL(file)}
          ></video>
        </div>
      ) : (
        <section className={`dragDropZone ${formatError || sizeError ? 'errorZone' : undefined}`}>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <img
              src={formatError || sizeError ? UploadFileError : UploadFileImg}
              alt={t("Upload")}
            />
            {renderInfo()}
          </div>
        </section>
      )}
    </>
  );
}

export default VideoUpload;
